import type { Intent } from '@jet/environment/dispatching';
import type { Opt } from '@jet/environment/types/optional';
import type { PageChangeInstruction } from './../../models/invalidation/change-instruction/PageChangeInstruction';

export interface PaginationIntent extends Intent<PaginationResult> {
    url?: string;
    id?: string;
}

interface SingleChangePaginationResult {
    pageChangeInstruction: PageChangeInstruction;
    nextIntent?: Opt<PaginationIntent>;
}

interface MultipleChangePaginationResult {
    pageChangeInstructions: PageChangeInstruction[];
    nextIntent?: Opt<PaginationIntent>;
}
export type PaginationResult =
    | SingleChangePaginationResult
    | MultipleChangePaginationResult;

export function isMultipleChangePaginationResult(
    result: PaginationResult,
): result is MultipleChangePaginationResult {
    return 'pageChangeInstructions' in result;
}
